/*!
 * jQuery collectionItemToggler
 *
 * Toggle the visibility of items in a collection.
 */
(function ($) {

var pluginName = 'collectionItemToggler',
  defaults = {
    initialItemsCount: 3,

    itemsContainerSelector: '.js-collection-item-toggler-items',
    itemSelector: '',

    collapsed: true,

    toggleButtonSelector: '.js-collection-item-toggler-button',
    toggleButtonTextShow: '+ Show all',
    toggleButtonTextHide: '- Hide extra',
    toggleButtonTemplate: '<a href="#">{{ buttonText }}</a>'
  };

function getToggleButtonTemplate(options) {
  var buttonText = options.collapsed ? options.toggleButtonTextShow : options.toggleButtonTextHide,
      template = options.toggleButtonTemplate;

  template = template.replace('{{ buttonText }}', buttonText);

  return template;
}

function Plugin(element, options) {
  this.element = element;
  this.options = $.extend({}, defaults, options);

  this._defaults = defaults;
  this._name = pluginName;

  this.init();
}

Plugin.prototype = {
  init: function () {
    var $items = this._getItems(this.element, this.options);

    // Don't bother doing anything if there are less than or equal amount of
    // items that should be shown initially.
    if (this.options.initialItemsCount >= $items.length) {
      return;
    }

    this.$toggleButton = this._getToggleButton(this.element, this.options);
    this.$toggleButton.on('click', this.onToggleButtonClick.bind(this));
    this.renderToggleButton(this.element, this.options);

    if (this.options.collapsed) {
      this.hideItems(this.element, this.options);
    }
  },

  onToggleButtonClick: function (ev) {
    ev.preventDefault();

    if (this.options.collapsed) {
      this.showItems(this.element, this.options);
    } else {
      this.hideItems(this.element, this.options);
    }

    this.options.collapsed = !this.options.collapsed;

    this.renderToggleButton(this.element, this.options);
  },

  renderToggleButton: function (el, options) {
    this.$toggleButton.html(getToggleButtonTemplate(options));
  },

  showItems: function (el, options) {
    var $items = this._getItems(el, options);
    $items.show();
  },

  hideItems: function (el, options) {
    var threshold = this._threshold(el, options),
        $items = this._getItems(el, options);

    // Filter collection to include only items after the initial shown ones.
    $items = $items.filter(function (index) {
      return index > threshold;
    });

    $items.hide();
  },

  _getToggleButton: function (el, options) {
    var $toggleButtonContainer = $(el).find(options.toggleButtonSelector);
    return $toggleButtonContainer;
  },

  _getItems: function (el, options) {
    var $itemsContainer = $(el).find(options.itemsContainerSelector),
        $items = $itemsContainer.children(options.itemSelector);
    return $items;
  },

  _threshold: function (el, options) {
    var initialItemsCount = parseInt(options.initialItemsCount, 10) - 1;
    return initialItemsCount >= 0 ? initialItemsCount : 0;
  }
};

$.fn[pluginName] = function (options) {
  return this.each(function () {
    if (!$.data(this, 'plugin_' + pluginName)) {
      $.data(this, 'plugin_' + pluginName,
        new Plugin(this, options));
    }
  });
};

})(jQuery, window, document);
